export default "/images/e9e1afa12c1ffe3a1a0b5e120151893b.avif";